// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {};

export const quizTemplateSlice = createSlice({
  name: 'quizTemplate',
  initialState,
  reducers: {},
});

export const {} = quizTemplateSlice.actions;

export default quizTemplateSlice.reducer;
